export default __webpack_public_path__ + "img/Cinnamomum_camphora.57ad1fe9.jpg";